var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  "+_vm._s(_vm.contactType())+"\n\n  "),_c('message-object',{attrs:{"tooltip":_vm.messageContent(),"type":"Message"}}),_vm._v("\n\n  sent to user,\n\n  "),_c('user-object',{attrs:{"entity-id":_vm.userId(),"name":_vm.userName(),"open-new":true,"tooltip":_vm.userProfile()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }